module.exports = __webpack_public_path__ + "static/img/none-data.274ee1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/imgs/none-data.png
// module id = Za4K
// module chunks = 34